// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".recipeHeader{font-size:1.5em;margin-bottom:.4em}\n", "",{"version":3,"sources":["webpack://./jsm/FactoryGame/Components/Recipe.sass"],"names":[],"mappings":"AAAA,cACI,eAAgB,CAChB,kBAAmB","sourcesContent":[".recipeHeader {\n    font-size: 1.5em;\n    margin-bottom: .4em; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
